import { useState } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import SummaryInvoices from '../../../components/ElectronicBilling/SummaryInvoices';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import ConfiguredRutState from '../../../components/ElectronicBilling/ConfiguredRutState';
import useConfiguredBillingRuts from '../../../hooks/useConfiguredBillingRuts';

const SummaryInvoice = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const { ruts, loading, error, reload } = useConfiguredBillingRuts();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      {loading ? <ConfiguredRutState loading /> : error || ruts.length === 0 ? (
        <ConfiguredRutState error={error} onRetry={reload} />
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="billing ruts tabs">
              {ruts.map((rutData) => (
                <Tab key={rutData.rut} label={rutData.rut} />
              ))}
            </Tabs>
          </Box>

          {ruts.map((rutData, index) => (
            <CustomTabPanel key={rutData.rut} value={tabValue} index={index}>
              <PageHeader title={t('summary_invoices')} subtitle={t('summary_invoices_desc')} />
              <SummaryInvoices selectedRut={rutData.rut} />
            </CustomTabPanel>
          ))}
        </>
      )}
    </div>
  );
};

export default SummaryInvoice;
